module.exports = __webpack_public_path__ + "static/media/global-shoppng-23.1410cd3b.png";